import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'address-types' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
